import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const CrossBoldIcon: FunctionComponent<IconProps> = ({
  fill,
  customColour,
  width = 20,
  height = 20,
  ...rest
}) => {
  const className = customColour ? '' : 'accentColor'

  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="M16.1 2l2.2 2.1-6 6 6 6-2.2 2.2-6-6-6 6L2 16l6-6-6-6L4.1 2l6 6 6-6z"
        fill={customColour}
        className={styles[className]}
        fillRule="evenodd"
      />
    </Icon>
  )
}
